import { iFacadeApi } from '@andbank-myinvestor/arq/lib/onboarding';
import i18next, { i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';

interface i18nextConfigConfig {
	langCode: () => string;
	language: () => { [id: string]: string };
	changeLanguage: (lang: string) => Promise<{ [id: string]: string }>;
}

const innerStore = {} as i18nextConfigConfig;

const i18nextConfig = ({
	langCode,
	language,
	changeLanguage,
}: i18nextConfigConfig): i18n => {
	innerStore.langCode = langCode;
	innerStore.language = language;
	innerStore.changeLanguage = changeLanguage;

	i18next
		.use(initReactI18next) // passes i18n down to react-i18next
		.init({
			resources: {
				[langCode()]: {
					translation: language(),
				},
			},
			lng: langCode(),

			nsSeparator: false,

			interpolation: {
				escapeValue: false, // react already safes from xss
			},
		});

	return i18next;
};

const i18nextChangeLanguage = async (langCode: string) => {
	const language = await innerStore.changeLanguage(langCode);

	i18next.addResourceBundle(langCode, 'translation', language, false, true);
	await i18next.changeLanguage(langCode);
	return i18next;
};

const i18nextInitializer = async (api: iFacadeApi) => {
	i18nextConfig({
		langCode: api.lang.currentLangCode,
		language: api.lang.currentLanguage,
		changeLanguage: api.lang.changeLanguage,
	});
};

export { i18nextConfig, i18nextChangeLanguage, i18nextInitializer };
